import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSearch } from "../hooks/useSearch";

export default function Header({ user, isAuthenticated, isAdmin, onLogout }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { searchQuery, handleSearch } = useSearch();
  const [localSearchQuery, setLocalSearchQuery] = useState(searchQuery);

  // Đồng bộ localSearchQuery với searchQuery từ context
  useEffect(() => {
    setLocalSearchQuery(searchQuery);
  }, [searchQuery]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    handleSearch(localSearchQuery);
  };

  const handleSearchInputChange = (e) => {
    setLocalSearchQuery(e.target.value);
  };

  // Xử lý realtime search khi user gõ
  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch(localSearchQuery);
    }
  };

  return (
    <header className="header">
      <div className="header__container">
        <div className="header__left">
          <div className="header__logo">
            <Link to="/">
              <img
                src="/LogoReviewTruong.svg"
                alt="Review Trường"
                className="header__logo-image"
              />
              <h1>Review Trường</h1>
            </Link>
          </div>
        </div>
        <form onSubmit={handleSearchSubmit} className="header__search">
          <button type="submit" className="header__search-btn">
            <i className="fa-solid fa-magnifying-glass"></i>
          </button>
          <input
            type="text"
            className="header__search-input"
            placeholder="Tìm kiếm trường học..."
            value={localSearchQuery}
            onChange={handleSearchInputChange}
            onKeyDown={handleSearchKeyDown}
          />
        </form>
        <div className="header__right">
          <nav className="header__nav">
            <Link to="/" className="header__nav-link">
              Trang chủ
            </Link>
            <Link to="/schools" className="header__nav-link">
              Trường học
            </Link>
            <Link to="/reviews" className="header__nav-link">
              Đánh giá
            </Link>

            {!isAuthenticated ? (
              <>
                <Link to="/login" className="header__nav-link">
                  Đăng nhập
                </Link>
                <Link to="/register" className="header__nav-link">
                  Đăng ký
                </Link>
              </>
            ) : (
              <>
                {isAdmin && (
                  <Link to="/admin/dashboard" className="header__nav-link">
                    Quản trị
                  </Link>
                )}
                <Link to="/profile" className="header__nav-link">
                  Hồ sơ
                </Link>
                <button
                  onClick={onLogout}
                  className="header__nav-link--logout-button"
                >
                  Đăng xuất
                </button>
              </>
            )}
          </nav>

          <button
            className="header__mobile-menu"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span className="header__mobile-icon"></span>
          </button>
        </div>
      </div>

      {/* Mobile navigation menu */}
      <div
        className={`header__mobile-nav ${
          mobileMenuOpen ? "header__mobile-nav--open" : ""
        }`}
      >
        <Link to="/" className="header__mobile-nav-link">
          Trang chủ
        </Link>
        <Link to="/schools" className="header__mobile-nav-link">
          Trường học
        </Link>
        <Link to="/reviews" className="header__mobile-nav-link">
          Đánh giá
        </Link>

        {!isAuthenticated ? (
          <>
            <Link to="/login" className="header__mobile-nav-link">
              Đăng nhập
            </Link>
            <Link to="/register" className="header__mobile-nav-link">
              Đăng ký
            </Link>
          </>
        ) : (
          <>
            {isAdmin && (
              <Link to="/admin/dashboard" className="header__mobile-nav-link">
                Quản trị
              </Link>
            )}
            <Link to="/profile" className="header__mobile-nav-link">
              Hồ sơ
            </Link>
            <button onClick={onLogout} className="header__mobile-nav-link">
              Đăng xuất
            </button>
          </>
        )}
      </div>
    </header>
  );
}
